import React from 'react';
import { V1FormsList } from './V1FormsList';

/**
 * V1 Event Forms Page - FROZEN
 *
 * This component displays forms for V1 events.
 * It uses the V1-specific forms list component with custom naming support.
 * 
 * DO NOT add V2 features to this component.
 * DO NOT mix V1/V2 logic.
 */
export const FormsPageV1: React.FC = () => {
  // All the logic is in V1FormsList to keep separation clear
  return <V1FormsList />;
};